var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "table-header",
      class: {
        "table-header--sortable": !!_vm.header.sortable,
        "table-header--sorted": _vm.header.key === _vm.sortBy,
      },
      on: { click: _vm.setSortBy },
    },
    [_vm._v(" " + _vm._s(_vm.header.text) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }